import { useSelector } from 'react-redux';
import { BeatIntervalsSelection } from '../../plot/components/BeatIntervalSelection';
import { EpisodeMeasurementTool } from '../../episodeMeasurement/components/EpisodeMeasurementTool';
import { RulerTool } from '../../ruler/components/RulerTool';
import { Zoom } from '../../scatter/components/zoom';
import { hasParentOnsetsSelector } from '../../scatter/selectors/scatter.selectors';
import { OpenInNewLink } from '../components/OpenInNewLink';
import { ApplicationPath } from '../types/application-path.types';
import { DisplayDropdown } from '../../resting/DisplayDropdown';
import { ShowDelineation } from '../../resting/ShowDelineation';
import { LeadChange } from '../../resting/LeadChange';
import { AmplitudeTool } from '../../resting/AmplitudeTool';
import { Ruler2dTool } from '../../ruler2d/components/Ruler2dTool';
import { isRestingStripSelector } from '../selectors/ecg.selectors';

export const useToolbox = (path: ApplicationPath | null) => {
  const hasParentHolter = useSelector(hasParentOnsetsSelector);
  const isRestingStrip = useSelector(isRestingStripSelector);
  const tools = [];

  switch (path) {
    case 'zoom':
      isRestingStrip
        ? tools.push(<Ruler2dTool key='ruler2d' />)
        : tools.push(<RulerTool key='ruler' />);
      tools.push(<BeatIntervalsSelection key='beatInterval' />);
      break;
    case 'resting':
      tools.push(<Ruler2dTool key='ruler2d' />);
      tools.push(<BeatIntervalsSelection key='beatInterval' />);
      tools.push(<ShowDelineation />);
      tools.push(<AmplitudeTool />);
      tools.push(<LeadChange />);
      tools.push(<DisplayDropdown />);
      break;
    case 'hr':
      tools.push(<RulerTool key='ruler' />);
      tools.push(<EpisodeMeasurementTool />);
      if (hasParentHolter) {
        tools.push(<Zoom key='zoom' />);
      }
      tools.push(<BeatIntervalsSelection key='beatInterval' />);
      break;
    case 'ilr':
      tools.push(<RulerTool key='ruler' />);
      tools.push(<BeatIntervalsSelection key='beatInterval' />);
      break;
    case 'zoom-noise':
      tools.push(<Ruler2dTool key='ruler2d' />);
      break;
    default:
      tools.push(<RulerTool key='ruler' />);
      break;
  }

  if (hasParentHolter) {
    tools.push(<OpenInNewLink key='holterLink' />);
  }
  return tools;
};
